import renderTags from "./modules/render-tags";
import parseExamples from "./modules/parse-examples";
import {uploaderSetup, mainUploadButtonInit} from "./modules/uploader";

document.addEventListener('DOMContentLoaded', () => {
  const localFullData = {};
  let itemCounter = 1;
  let firstContentItemRender = false;
  const dataForSending = {name: "", tagId: null, folderName: null}
  let quiz = false;
  let userLanguage;
  const currentItem = {id: ''}
  const tagsRefInfoData = {}

  const counterCurrentImage = document.querySelector('[data-js="content-currnet-num"]');
  const refInfoButton = document.querySelector('[data-js="ref-info-button"]');
  const refInfoTextBlock = document.querySelector('[data-js="ref-info-text"]');
  const taskInfo = document.querySelector('[data-js="content-task"]');

  const getData = (url) => {
    return fetch(url).
    then(response => response.json())
    .catch(data => {
      console.log('Error', data);
    });
  }

  const makeRequest = (url, param) => {
    return fetch(url, param)
    .then(response => {
      if (response.status === 200) {
        return response.json()
      } else {
        const error = new Error(`We have some problem, code: ${response.status}`)
        error.response = response
        throw error
      }
    })
    .catch(error => {
      console.log('Error', error)
      window.location.href = 'https://mrabbit.org/?references'
    })
  }

  const params = new URLSearchParams(window.location.search);
  const baseId = window.location.search.split('&')[0].slice(1);
  const baseTag = params.get('tag');
  const baseType = params.get('type');
  const action = params.get('action');
  const filtersValue = params.get('filters');
  action == 'check' && baseId != 'references' ? quiz = true : quiz = false;

  userLanguage = navigator.language?.slice(0, 2);

  if (!filtersValue && quiz) {
    params.set('filters', "yes-no-wait");
    const newParams = params.toString().split('&').filter(p => !p.startsWith(baseId)).join('&');
    history.pushState(null, '', `?${baseId}${newParams ? '&' + newParams : ''}`);
  }

  getData(`./ref.php?id=${baseId}${action ? '&check=true' : ''}`)
  .then(data => {
    if (!data) {
      window.location.href = "https://mrabbit.org/?references";
      return;
    }

    if (!data.data || data.data.length == 0) {
      const placeholder = document.querySelector('[data-js="nodata-placeholder"]');
      placeholder.classList.add('nodata-placeholder_active');
      return;
    }
    
    // Comment if no need uploader
    // if (!action && baseId != 'references') {
    //   if (data.key) {
    //     uploaderSetup(makeRequest, data.key, baseId, dataForSending);
    //     mainUploadButtonInit();
    //   }
    // }

    data.data.forEach(item => {
      localFullData[item.id] = item;
    })

    document.title = data.model;

    if (data.data.length == 0) {
      refInfoButton.style.display = 'none';
      counterCurrentImage.style.display = 'none';
      taskInfo.style.display = 'none';
      return
    }

    const firstKey = Object.keys(localFullData)[0];
    let itemData = localFullData[firstKey].tags[0];
    let foundTag = false;

    data.data.some(category => {
      return category.tags.some(tag => {
        if (tag.title === baseTag) {
          itemData = tag;
          foundTag = true;
          return true;
        }
        return false;
      });
    });

    if (!foundTag) {
      params.set('tag', itemData.title.trim()); 
      const newParams = params.toString().split('&').filter(p => !p.startsWith(baseId)).join('&');
      history.pushState(null, '', `?${baseId}${newParams ? '&' + newParams : ''}`);
    }

    currentItem.id = itemData.id;
    renderTags(getData, parseExamples, localFullData, renderThumbs, renderAllContent, renderContentItem, swipeToContentItem, removeListenerForBodyClose, currentItem, dataForSending, baseId, params, quiz, tagsRefInfoData);
    if (window.innerWidth < 992) {
      renderAllContent(itemData);
    } else {
      renderThumbs(itemData, 0);
    }

    taskInfo.innerHTML = `${itemData.img > 0 ? `<span>${itemData.img} images</span>` : ''}${itemData.redgifs > 0 ? `<span>${itemData.redgifs} video</span>` : ''}${itemData.carousel > 0 ? `<span>${itemData.carousel} carousel</span>` : ''}${(!itemData.img && !itemData.redgifs && !itemData.carousel) ? 'No required items' : ''}`;

    if(quiz) {
      const pcWrapper = document.querySelector('[data-js="filters-pc"]');
      const mobWrapper = document.querySelector('[data-js="filter-mob"]');
      const tagListWrapper = document.querySelector('[data-js="tag-list-wrapper"]');
      tagListWrapper.classList.add('workspace__category-col_check');
  
      if (window.innerWidth < 992) {
        mobWrapper.classList.add('filter-mobile');
      } else {
        pcWrapper.classList.add('header__filter');
      }
  
      createFilterItem("Yes", "yes");
      createFilterItem("No", "no");
      createFilterItem("Wait", "wait");
  
      function createFilterItem(name, status) {
        const filterItem = document.createElement('div');
        filterItem.classList.add('form-check', 'form-switch', 'header__filter-item');
        filterItem.innerHTML = `
        <input class="form-check-input" type="checkbox" id="status${name}" ${filtersValue ? (filtersValue.split('-').some(value => value == name.toLowerCase()) ? "checked" : "") : "checked"}>
        <label class="form-check-label" for="status${name}">${name}</label>`;
  
        filterItem.addEventListener('change', (e) => changeItemList(e, status));
  
        window.innerWidth < 992 ? mobWrapper.append(filterItem) : pcWrapper.append(filterItem);
      }
  
      function changeItemList(e, status) {
        const items = document.querySelectorAll(`[data-model-ready="${status}"]`);
        let filters = params.get('filters') ? params.get('filters').split('-') : [];

        if (!e.target.checked) {
          filters = filters.filter(element => element !== status);
          items.forEach(el => el.classList.add('category__list-item_hidden'));
        } else {
          if (!filters.includes(status)) {
            filters.push(status);
          }
          items.forEach(el => el.classList.remove('category__list-item_hidden'));
        }

        //render active item
        const activeItem = document.querySelector('.category__list-item_active');
        const vissibleCategory = document.querySelector('[data-js="tag-list"] li:not(.category__list-item_hidden)');

        if (activeItem && vissibleCategory && activeItem.classList.contains('category__list-item_hidden')) {
          activeItem.classList.remove('category__list-item_active');

          vissibleCategory.classList.add('category__list-item_active');
          currentItem.id = vissibleCategory.dataset.tagId;

          if (window.innerWidth < 992) {
            vissibleCategory ? renderAllContent(tagsRefInfoData[vissibleCategory.dataset.tagId]) : null;
          } else {
            vissibleCategory ? renderThumbs(tagsRefInfoData[vissibleCategory.dataset.tagId], 0) : null;
          }

          params.set('tag', tagsRefInfoData[vissibleCategory.dataset.tagId].title);
          params.set('type', String("all").trim());
        }

        params.set('filters', filters.join('-'));
        const newParams = params.toString().split('&').filter(p => !p.startsWith(baseId)).join('&');
        history.pushState(null, '', `?${baseId}${newParams ? '&' + newParams : ''}`);
      }
  
      if (filtersValue) {
        const allItems = document.querySelectorAll(`[data-model-ready]`);
        allItems.forEach(item => item.classList.add('category__list-item_hidden'));
  
        const dividedValues = filtersValue.split('-');
  
        dividedValues.forEach(status => {
          const items = document.querySelectorAll(`[data-model-ready="${status}"]`);
          items.forEach(el => el.classList.remove('category__list-item_hidden'));
        })
      }
    }
  });

  let swiper;
  initSwiper('.swiper-main');

  function initSwiper(swiperClass) {
    swiper = new Swiper(swiperClass, {
      loop: true,
  
      pagination: {
        el: '.swiper-pagination',
      },
    
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
  
      slidesPerView: 1,
    
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  }

  let swiperMobile;
  if (window.innerWidth < 992) {
    swiperMobile = new Swiper('.swiper-mobile', {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 40,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      on: {
        slideChange: function () {
          const activeSlide = this.slides[this.activeIndex];
          const contentType = activeSlide.dataset.type;
          
          params.set('type', contentType.trim());
          const newParams = params.toString().split('&').filter(p => !p.startsWith(baseId)).join('&');
          history.pushState(null, '', `?${baseId}${newParams ? '&' + newParams : ''}`);
        }
      }
    });
  }

  let statusListenerForBodyClose = false;
  const tagListMobToggle = document.querySelector('[data-js="tag-list-toggle"]');
  const workspace = document.querySelector('[data-js="workspace-interface"]');

  tagListMobToggle.addEventListener('click', () => {
    workspace.classList.toggle('workspace__interface_active');
    tagListMobToggle.classList.toggle('header__mob-menu_active');

    if (statusListenerForBodyClose) {
      return;
    }

    setTimeout(() => {
      document.querySelector('body').addEventListener('click', listenerForBodyClose)
      statusListenerForBodyClose = true;
    },200)
  });

  function removeListenerForBodyClose() {
    document.querySelector('body').removeEventListener('click', listenerForBodyClose);
    statusListenerForBodyClose = false;
  }

  function listenerForBodyClose(e) { 
    if (!workspace.contains(e.target) && !document.querySelector('[data-js="loader-wrapper"]').contains(e.target)) {
      if (e.target != tagListMobToggle) {
        workspace.classList.remove('workspace__interface_active');
        tagListMobToggle.classList.remove('header__mob-menu_active');
      }

      document.querySelector('body').removeEventListener('click', listenerForBodyClose);
      statusListenerForBodyClose = false;
    }
  }

  refInfoButton.addEventListener('click', () => {
    const tagInfo = tagsRefInfoData[currentItem.id];
    refInfoTextBlock.innerHTML = '';

    const langSuffix = (userLanguage == 'ru' || userLanguage == 'uk') ? '' : '_en';
    
    const refInfoKey = `ref_info${langSuffix}`;
    const refInfoCrslKey = `ref_info_crsl${langSuffix}`;
    const refInfoImgKey = `ref_info_img${langSuffix}`;
    const refInfoRedgifsKey = `ref_info_redgifs${langSuffix}`;

    const noRefs =
      !tagInfo[refInfoKey] &&
      !tagInfo[refInfoCrslKey] &&
      !tagInfo[refInfoImgKey] &&
      !tagInfo[refInfoRedgifsKey];

    if (noRefs) {
      const clearBlock = document.createElement('div');
      clearBlock.classList.add('ref-info__item');
      clearBlock.innerHTML = userLanguage === 'ru'
        ? "Информация по этому тегу отсутствует"
        : "There is no reference info for this tag";
      refInfoTextBlock.append(clearBlock);
      return;
    }

    if (tagInfo[refInfoKey]) {
      let message = '';
      if (tagInfo.img) message += `${tagInfo.img} img,`;
      if (tagInfo.redgifs) message += ` ${tagInfo.redgifs} video,`;
      if (tagInfo.carousel) message += ` ${tagInfo.carousel} carousel,`;
      message = message.slice(0, -1);

      const globalText = document.createElement('div');
      globalText.classList.add('ref-info__item');
      globalText.innerHTML = `
        <h5 class="modal-title ref-info__item-title">${message}</h5>
        <p>${tagInfo[refInfoKey]}</p>`;
      refInfoTextBlock.append(globalText);
    }

    if (tagInfo.img && tagInfo[refInfoImgKey]) {
      const imgText = document.createElement('div');
      imgText.classList.add('ref-info__item');
      imgText.innerHTML = `
        <h5 class="modal-title ref-info__item-title">${tagInfo.img} img</h5>
        <p>${tagInfo[refInfoImgKey]}</p>`;
      refInfoTextBlock.append(imgText);
    }

    if (tagInfo.redgifs && tagInfo[refInfoRedgifsKey]) {
      const redgifsText = document.createElement('div');
      redgifsText.classList.add('ref-info__item');
      redgifsText.innerHTML = `
        <h5 class="modal-title ref-info__item-title">${tagInfo.redgifs} video</h5>
        <p>${tagInfo[refInfoRedgifsKey]}</p>`;
      refInfoTextBlock.append(redgifsText);
    }

    if (tagInfo.carousel && tagInfo[refInfoCrslKey]) {
      const carouselText = document.createElement('div');
      carouselText.classList.add('ref-info__item'); 
      carouselText.innerHTML = `
        <h5 class="modal-title ref-info__item-title">${tagInfo.carousel} carousel</h5>
        <p>${tagInfo[refInfoCrslKey]}</p>`;
      refInfoTextBlock.append(carouselText);
    }
  });

  document.querySelector('[data-js="image-workspace"] img.workspace-content__picture').addEventListener('load', (e) => {
    e.currentTarget.classList.add('workspace-content__picture_loaded')
    document.querySelector('[data-js="image-workspace"] .workspace-content__loading-placeholder').style.display = 'none'
  })

  

  function renderThumbs(itemData, activeThumb) {
    if (!itemData) return;

    const parseRes = parseExamples(itemData);
    const parsedExamples = parseRes.exampleArray;
    const contentStartIndexes = parseRes.contentStartIndexes;

    if(parsedExamples.length == 0) {
      document.querySelector('[data-js="image-workspace"]').dataset.workspaceStatus = '';
      document.querySelector('[data-js="video-workspace"]').dataset.workspaceStatus = '';
      document.querySelector('[data-js="carousel-workspace"]').dataset.workspaceStatus = '';
      document.querySelector('[data-js="content-currnet-num"]').innerHTML = '0/0';
      return;
    }

    const thumbsWrapper = document.querySelector('[data-js="thumbs-wrapper"]');
    thumbsWrapper.innerHTML = '';

    parsedExamples.forEach((exampl, ind) => {
      let imageThumb;
      let dynamicVideoClass = '';

      imageThumb = `https://mrabbit.org/assets/thumbs/${exampl.src_thumbnail}`;

      if (exampl.type == 'redgifs') {
        dynamicVideoClass = "thumbs__list-item_video-mod";
      }

      const image = document.createElement('li');

      if (ind == activeThumb) {
        image.classList.add('thumbs__list-item', 'thumbs__list-item_type-mode','thumbs__list-item_active');
        counterCurrentImage.innerHTML = `${activeThumb + 1}/${parsedExamples.length}`;
      } else {
        image.classList.add('thumbs__list-item', 'thumbs__list-item_type-mode');
      }

      let typeClass;
      if (exampl.type == 'img') {
        typeClass = 'thumbs-item__type-block_img';
      } else if (exampl.type == "carousel") {
        typeClass = 'thumbs-item__type-block_carousel';
      } else if (exampl.type == 'redgifs') {
        typeClass = 'thumbs-item__type-block_video';
      }

      image.innerHTML = `
      <img class="${dynamicVideoClass}" src="${imageThumb}" alt="thumb" ${exampl.type == "redgifs" ? `onerror="this.onerror=null; this.src='./assets/icons/camera-reels.svg'; this.alt='';"` : ''}>
      <div class="thumbs-item__type-block ${typeClass}"></div>`;

      thumbsWrapper.append(image);

      image.addEventListener('click', (event) => {
        if (!event.currentTarget.classList.contains('thumbs__list-item_active')) {
          thumbsWrapper.querySelector('.thumbs__list-item_active').classList.remove('thumbs__list-item_active');
          event.currentTarget.classList.add('thumbs__list-item_active');
          renderContentItem(exampl);
          counterCurrentImage.innerHTML = `${ind+1}/${parsedExamples.length}`;

          params.set('type', exampl.type.trim());
          const newParams = params.toString().split('&').filter(p => !p.startsWith(baseId)).join('&');
          history.pushState(null, '', `?${baseId}${newParams ? '&' + newParams : ''}`);
        }
      });      
    });
    
    if (!firstContentItemRender && baseType) {
      firstContentItemRender = true;
      renderContentItem(parsedExamples[contentStartIndexes[baseType]]);
      thumbsWrapper.querySelector('.thumbs__list-item_active').classList.remove('thumbs__list-item_active');
      thumbsWrapper.querySelectorAll('li')[contentStartIndexes[baseType]].classList.add('thumbs__list-item_active');
      counterCurrentImage.innerHTML = `${contentStartIndexes[baseType] + 1}/${parsedExamples.length}`;
    } else {
      renderContentItem(parsedExamples[0]);
    }
  }

  function renderAllContent(itemData) {
    const parseRes = parseExamples(itemData);
    const parsedExamples = parseRes.exampleArray;
    const contentStartIndexes = parseRes.contentStartIndexes;

    const allInOneWrapper = document.querySelector('[data-js="all-in-one-workspace"]');
    allInOneWrapper.innerHTML = '';

    let swiperCounter = 0;

    if(parsedExamples.length == 0) {
      return;
    }

    parsedExamples.forEach(item => {
      
      const example = document.createElement('div');
      example.classList.add('workspace-all__item', 'swiper-slide');
      item.type == 'redgifs' ? example.classList.add('workspace-all__item_video') : null;
      example.id = `example${itemCounter}`;
      example.dataset.type = item.type;
      itemCounter++;

      if (item.type == 'img') {
        example.innerHTML = `<img src="https://mrabbit.org/assets/img/${item.src}">`;
      }

      if (item.type == 'redgifs') {
        example.innerHTML = `<div class="gifs__player gifs__player_embedded">
        <div class="gifs__player_wrapper">
          <iframe src="${item.src.replace('https://www.redgifs.com/watch/', 'https://www.redgifs.com/ifr/')}" frameborder="0" scrolling="no" width="100%" height="100%" style="position:absolute; top:0; left:0;" allowfullscreen=""></iframe>
        </div>
      </div>`;
      }

      if (item.type == 'carousel') {
        const swiperId = swiperCounter;
        swiperCounter++;

        let slides = '';
        item.items.forEach(image => {
          slides += `<div class="swiper-slide workspace-carousel__slide">
                <img src="https://mrabbit.org/assets/img/${image.src}" alt="photo">
              </div>`
        });

        example.innerHTML = `<div class="workspace-content__carousel workspace-content__carousel_inner">
          <div class="swiper swiper-${swiperId} swiper-innner">
            <div data-js="swiper-slides-wrapper" class="swiper-wrapper">
              ${slides}
            </div>
      
            <div class="swiper-pagination"></div>

            <div class="swiper-button-prev swiper-button-prev-${swiperId}"></div>
            <div class="swiper-button-next swiper-button-next-${swiperId}"></div>

            <div class="swiper-scrollbar"></div>
          </div>
        </div>`;

        setTimeout(() => {
          const swiper = new Swiper(example.querySelector(`.swiper-${swiperId}`), {
            pagination: {
              el: `.swiper-${swiperId} .swiper-pagination`,
            },
          
            navigation: {
              nextEl: `.swiper-button-next.swiper-button-next-${swiperId}`,
              prevEl: `.swiper-button-prev.swiper-button-prev-${swiperId}`,
            },
        
            slidesPerView: 1,
          
            scrollbar: {
              el: `.swiper-${swiperId} .swiper-scrollbar`,
            },
          });
        }, 200);
      }

      allInOneWrapper.append(example);

      itemCounter = 1;

      if (!firstContentItemRender && baseType) {
        firstContentItemRender = true;

        swipeToContentItem(contentStartIndexes[baseType]);
      } else {
        setTimeout(() => {
          swiperMobile.update();
          swiperMobile.slideTo(0);
        }, 100)
      }
    });
  }

  function swipeToContentItem(itemIndex) {
    setTimeout(() => {
      swiperMobile.update();
      swiperMobile.slideTo(itemIndex);
    }, 200)
  }

  function renderContentItem(item) {
    const imageWorkspace = document.querySelector('[data-js="image-workspace"]');
    const videoWorkspace = document.querySelector('[data-js="video-workspace"]');
    const carouselWorkspace = document.querySelector('[data-js="carousel-workspace"]');

    videoWorkspace.dataset.workspaceStatus = '';
    imageWorkspace.dataset.workspaceStatus = '';
    carouselWorkspace.dataset.workspaceStatus = '';

    if (item.type == 'img') {
      imageWorkspace.dataset.workspaceStatus = 'active';
      imageWorkspace.querySelector('img').src = `https://mrabbit.org/assets/img/${item.src}`;
    }

    if (item.type == 'redgifs') {
      videoWorkspace.dataset.workspaceStatus = 'active';
      document.querySelector('[data-js="gifs-player-embedded"]').src = item.src.replace('https://www.redgifs.com/watch/', 'https://www.redgifs.com/ifr/');
    }

    if (item.type == 'carousel') {
      const wrapper = document.querySelector('[data-js="swiper-slides-wrapper"]');

      wrapper.innerHTML = '';

      const newSlides = [];
      item.items.forEach(image => {
        const slide = document.createElement('div');
        slide.classList.add('swiper-slide', 'workspace-carousel__slide');
        slide.innerHTML = `<img src="https://mrabbit.org/assets/img/${image.src}" alt="photo">`

        newSlides.push(slide);
      })

      setTimeout(() => {
        swiper.update();
        swiper.appendSlide(newSlides);
        swiper.slideTo(0);
      }, 100)

      carouselWorkspace.dataset.workspaceStatus = 'active';
    }
  }
});